import React, { useEffect, useId, useRef, useState } from "react";
import { Icon } from "@zorni/components-lib";
import styles from "../PartnerAnalyticsDashboard.module.css";

// Reusable "i" info bubble for card/chart headers across the partner
// analytics dashboard. Opens on hover or focus (desktop/keyboard) and toggles
// on click (touch devices, or to pin it open); closes on Escape or a click
// outside. Positioned top-right by the caller via a flex header row.
const InfoTooltip = ({ title, children, className }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const contentId = useId();

  useEffect(() => {
    if (!open) return undefined;

    const handlePointerDown = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  return (
    <div
      ref={wrapperRef}
      className={`${styles.infoTooltipWrap} ${className || ""}`.trim()}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className={styles.infoTooltipTrigger}
        aria-label={`Informations : ${title}`}
        aria-describedby={contentId}
        aria-expanded={open}
        onClick={() => setOpen((previous) => !previous)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
      >
        <Icon name="iconInfo" size="sm" color="muted" />
      </button>

      {open ? (
        <div id={contentId} role="tooltip" className={styles.infoTooltipPopover}>
          <div className={styles.infoTooltipTitle}>{title}</div>
          <div className={styles.infoTooltipBody}>{children}</div>
        </div>
      ) : null}
    </div>
  );
};

export default InfoTooltip;
